import { Component, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormControl } from "@angular/forms";
import { BehaviorSubject, debounceTime, delay, distinctUntilChanged, map, of, shareReplay, tap } from "rxjs";
import { UpdateNoticeService } from "../service/updatenotice.service";
import mock from "../../../assets/validation-history.json";
import { setLoader } from "src/app/utils/set-loaders";
import { ValidationHistory } from "src/app/shared/models/ValidationHistory";
import { toSignal } from "@angular/core/rxjs-interop";

@Component({
  selector: "app-update-notice-validation-history",
  standalone: false,
  templateUrl: "./update-notice-validation-history.component.html",
  styleUrl: "./update-notice-validation-history.component.scss",
})
export class UpdateNoticeValidationHistoryComponent {
  private _activatedRoute = inject(ActivatedRoute);

  private _router = inject(Router);

  private _updateNoticeSercvice = inject(UpdateNoticeService);

  private _loaders$ = new BehaviorSubject({});

  updateNoticeId = this._activatedRoute.snapshot.params["id"];

  searchControl = new FormControl();

  columns = [
    {
      columnDef: "date",
      header: "Date",
      cell: (element: ValidationHistory) => `${element.date}`,
    },
    {
      columnDef: "result",
      header: "Result",
      cell: (element: ValidationHistory) => `${element.result}`,
    },
    {
      columnDef: "dataset",
      header: "Dataset",
      cell: (element: ValidationHistory) => `${element.dataset}`,
    },
    {
      columnDef: "version",
      header: "Version",
      cell: (element: ValidationHistory) => `${element.version}`,
    },
    {
      columnDef: "schema",
      header: "Profiles",
      cell: (element: ValidationHistory) => `${element.schema}`,
    },
    {
      columnDef: "bizrule",
      header: "Business Rules",
      cell: (element: ValidationHistory) => `${element.bizrule}`,
    },
  ];

  badgeIconLookup = {
    valid: {
      icon: "check_circle",
      color: "primary",
    },
    invalid: {
      icon: "error",
      color: "warn",
    },
    failed: {
      icon: "cancel",
      color: "warn",
    },
    pending: {
      icon: "schedule",
      color: "accent",
    },
  };

  private _updateNotice = toSignal(
    this._updateNoticeSercvice.getUpdateNotice(this.updateNoticeId).pipe(
      setLoader(this._loaders$, "updateNotice"),
      map((result) => result),
      tap((result) => {
        console.log(result, "### UPDATE NOTICE");
      })
    )
  );

  get updateNotice() {
    return this._updateNotice();
  }

  private _validationHistory = toSignal(
    of(mock)
      .pipe(delay(3000))
      .pipe(
        setLoader(this._loaders$, "validationHistory"),
        map((items: any) => items.map((item) => ValidationHistory.parse(item))),
        tap((result) => {
          console.log(result, "### VALIDATION HISTORY");
        }),
        shareReplay(1)
      )
  );

  get validationHistory() {
    return this._validationHistory();
  }

  private _loaders = toSignal(this._loaders$);

  get loaders() {
    return this._loaders();
  }

  private _searchTerm = toSignal(this.searchControl.valueChanges.pipe(debounceTime(450), distinctUntilChanged()));

  get searchTerm() {
    return this._searchTerm();
  }

  backToEditUN(): void {
    this._router.navigate(["/update/id", this.updateNoticeId]);
  }
}
